import { createContext, useContext } from 'react';

// Whether the page reading this is the one on screen.
//
// The shell keeps the last page of every section mounted, hidden, so
// going back to a section finds it as it was left: the open week, the
// filters, the selected row, the scroll position. A hidden page must not
// write to the shared chrome (the panel, the breadcrumb), so those read
// this. Outside the shell (tests, public pages) everything is active.
export const SectionActiveContext = createContext(true);

export const useSectionActive = (): boolean => useContext(SectionActiveContext);
